// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3YB2R","rootSuccess":"CompleteLink_rootSuccess__jNReg","rootFailure":"CompleteLink_rootFailure__2hrbT","isDisabled":"CompleteLink_isDisabled__1LYnW"};